import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import StatsSetCreateEditForm from './Components/StatsSetCreateEditForm';
import StatsSetApi from './StatsSetApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: StatsSetCreateEditForm,
                getCreate: StatsSetApi.create,
                defaults: {type: 'customGroup', stats:{}},
                successMessage: "StatsSet Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}